import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "mb-2" }
const _hoisted_2 = {
  key: 0,
  class: "mt-1"
}
const _hoisted_3 = ["for"]
const _hoisted_4 = { class: "mb-4" }
const _hoisted_5 = {
  key: 0,
  class: "mt-1"
}
const _hoisted_6 = ["for"]
const _hoisted_7 = { class: "flex items-center gap-3" }

import Button from 'primevue/button'
import Checkbox from 'primevue/checkbox'
import {
  ref,
  reactive,
  toRefs,
  watch,
  getCurrentInstance,
  onMounted,
  computed
} from 'vue'
import { useStore } from 'vuex'

const moduleStore = 'employee'

export default /*@__PURE__*/_defineComponent({
  __name: 'FilterOptions',
  props: {
  dataPositionList: {
    default: [] as any
  },
  dataRegionList: {
    default: [] as any
  },
  selectedFilter: {
    default: {
      positions: [] as any,
      regions: [] as any
    }
  }
},
  emits: ["onSubmit", "hidePanel"],
  setup(__props, { emit: __emit }) {

const props = __props

const {
  dataPositionList,
  dataRegionList,
  selectedFilter
} = toRefs(props)

const emit = __emit

const store = useStore()
const app = getCurrentInstance()
const {
  $icon
} = app!.appContext.config.globalProperties
const icon = $icon
const selectedFieldIndex = ref(null) as any
const appliedOptions = ref({
  positions: [] as any,
  regions: [] as any
})
const selectedFieldOption = computed(() => store.getters['employee/getEmployeeFilter'])
const selectedFieldOptionLocal = ref({
  positions: [] as any[],
  regions: [] as any[]
})

const deepClone = (v: any) => JSON.parse(JSON.stringify(v))

const selectedField = (val: any) => {
  if (selectedFieldIndex.value === val) {
    selectedFieldIndex.value = null
  } else {
    selectedFieldIndex.value = val
  }
}

const onSubmitAct = () => {
  store.dispatch('employee/setEmployeeFilter', selectedFieldOptionLocal.value)
  emit('onSubmit', selectedFieldOptionLocal.value)
  // eslint-disable-next-line no-use-before-define
  hidePanelAct()
}

const resetFilterAct = () => {
  selectedFieldOptionLocal.value = {
    positions: [],
    regions: []
  }
  store.dispatch('employee/flushEmployeeFilter')
  emit('onSubmit', selectedFieldOptionLocal.value)
  // eslint-disable-next-line no-use-before-define
  hidePanelAct()
}

const hidePanelAct = () => {
  emit('hidePanel')
}

// watch(selectedFieldOption.value, (val: any) => {
//   console.log('val', val)
//   console.log('selectedFieldOption', selectedFieldOption.value)
//   console.log('store', store.state[moduleStore].filters)
// })

onMounted(() => {
  console.log(selectedFilter.value)
  selectedFieldOptionLocal.value = deepClone(selectedFieldOption.value) || {
    positions: [],
    regions: []
  }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "flex items-center gap-2 cursor-pointer",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (selectedField(0)))
      }, [
        _createElementVNode("i", {
          class: _normalizeClass(["pi pi-angle-down text-xs", selectedFieldIndex.value === 0 ? 'color-primary' : ''])
        }, null, 2),
        _createElementVNode("div", {
          class: _normalizeClass(selectedFieldIndex.value === 0 ? 'color-primary' : '')
        }, _toDisplayString('Filter Divisi'), 2)
      ]),
      (selectedFieldIndex.value === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataPositionList), (data, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: data,
                class: "mb-1 ml-5"
              }, [
                _createVNode(_unref(Checkbox), {
                  modelValue: selectedFieldOptionLocal.value.positions,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedFieldOptionLocal.value.positions) = $event)),
                  inputId: `position${index}`,
                  value: data
                }, null, 8, ["modelValue", "inputId", "value"]),
                _createElementVNode("label", {
                  for: `position${index}`,
                  class: "ml-2"
                }, _toDisplayString(data?.name), 9, _hoisted_3)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: "flex items-center gap-2 cursor-pointer",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (selectedField(1)))
      }, [
        _createElementVNode("i", {
          class: _normalizeClass(["pi pi-angle-down text-xs", selectedFieldIndex.value === 1 ? 'color-primary' : ''])
        }, null, 2),
        _createElementVNode("div", {
          class: _normalizeClass(selectedFieldIndex.value === 1 ? 'color-primary' : '')
        }, _toDisplayString('Filter Wilayah'), 2)
      ]),
      (selectedFieldIndex.value === 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataRegionList), (data, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: data,
                class: "mb-1 ml-5"
              }, [
                _createVNode(_unref(Checkbox), {
                  modelValue: selectedFieldOptionLocal.value.regions,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedFieldOptionLocal.value.regions) = $event)),
                  inputId: `region${index}`,
                  value: data
                }, null, 8, ["modelValue", "inputId", "value"]),
                _createElementVNode("label", {
                  for: `region${index}`,
                  class: "ml-2"
                }, _toDisplayString(data?.name), 9, _hoisted_6)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_unref(Button), {
        class: "flex gap-2 extra-submit-button",
        style: {"border-color":"#04776D"},
        onClick: _cache[4] || (_cache[4] = ($event: any) => (resetFilterAct())),
        outlined: true
      }, {
        default: _withCtx(() => _cache[6] || (_cache[6] = [
          _createElementVNode("p", { class: "text-primary font-bold text-sm" }, _toDisplayString('Reset'), -1)
        ])),
        _: 1,
        __: [6]
      }),
      _createVNode(_unref(Button), {
        class: "mb-2 sm:mb-0 flex gap-2",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (onSubmitAct())),
        style: {"height":"-webkit-fill-available"}
      }, {
        default: _withCtx(() => _cache[7] || (_cache[7] = [
          _createElementVNode("p", { class: "text-white font-bold text-sm" }, _toDisplayString('Apply'), -1)
        ])),
        _: 1,
        __: [7]
      })
    ])
  ]))
}
}

})